import type { ReactNode } from 'react';
import React from 'react';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import type { IStyler } from '@alfa-bank/site-util-create-widget/src/models';
import type { TTag } from '@alfa-bank/site-text-v2/src/models';

export const BoldText = ({
    children,
    styler,
    tag,
}: {
    children?: ReactNode;
    styler?: IStyler;
    tag?: TTag;
}) => (
    <Text styler={styler} tag={tag} view="accent-primary-large">
        {children}
    </Text>
);
